import { useFormik, FormikHelpers } from "formik";
import * as Yup from "yup";

export interface ContactSalesFields {
  email: string;
  name: string;
  message: string;
}
const ContactSalesSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email field is required!"),
  name: Yup.string()
    .min(2, "Please add a valid name")
    .required("Name field is required!"),
  message: Yup.string().required("Message is required"),
});

const EMPTY_VALUES: ContactSalesFields = {
  email: "",
  name: "",
  message: "",
};

interface UseContactSalesFormOptions {
  initialValues?: Partial<ContactSalesFields>;
  enableReinitialize?: boolean;
  onSubmit: (
    values: ContactSalesFields,
    formikHelpers: FormikHelpers<ContactSalesFields>
  ) => Promise<any>;
}

export type ContactSalesFormik = ReturnType<typeof useContactSalesFormik>;

export const useContactSalesFormik = (opts: UseContactSalesFormOptions) => {
  return useFormik<ContactSalesFields>({
    initialValues: { ...EMPTY_VALUES, ...opts.initialValues },
    enableReinitialize: opts.enableReinitialize,
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: ContactSalesSchema,
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};
